// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportSpendingItemEntity from './entities/report-spending-item.json';
import reportSpendingItemMenu from '../pages/report-spending-item/menu.json';
import reportSpendingItemFullForm from '../pages/report-spending-item/forms/full.json';
import reportSpendingItemContextForm from '../pages/report-spending-item/forms/context.json';
import reportSpendingItemMiniForm from '../pages/report-spending-item/forms/mini.json';
import reportSpendingItemLookupForm from '../pages/report-spending-item/forms/lookup.json';
import reportSpendingItemTableView from '../pages/report-spending-item/views/table.json';
import reportSpendingItemCardsView from '../pages/report-spending-item/views/cards.json';
import reportSpendingItemDashboardView from '../pages/report-spending-item/views/dashboard.json';

/** Тип запису «Стаття видатків» зі сторінками пакета: меню, форми та подання з pages/report-spending-item/. */
export const reportSpendingItemDefinition: IRecordTypeDefinition = {
  ...reportSpendingItemEntity,
  views: assembleViewSet({
      table: reportSpendingItemTableView,
      cards: reportSpendingItemCardsView,
      dashboard: reportSpendingItemDashboardView,
  }),
  form: reportSpendingItemFullForm,
  forms: { full: reportSpendingItemFullForm, context: reportSpendingItemContextForm, mini: reportSpendingItemMiniForm, lookup: reportSpendingItemLookupForm },
  menu: reportSpendingItemMenu,
} as IRecordTypeDefinition;
